import { render, staticRenderFns } from "./MobileTop.vue?vue&type=template&id=b44f5ff6&scoped=true&"
import script from "./MobileTop.vue?vue&type=script&lang=js&"
export * from "./MobileTop.vue?vue&type=script&lang=js&"
import style0 from "./MobileTop.vue?vue&type=style&index=0&id=b44f5ff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44f5ff6",
  null
  
)

export default component.exports